var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpenBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5166 8.86344C1.5166 8.86344 3.5166 4.19678 8.18327 4.19678C12.8499 4.19678 14.8499 8.86344 14.8499 8.86344C14.8499 8.86344 12.8499 13.5301 8.18327 13.5301C3.5166 13.5301 1.5166 8.86344 1.5166 8.86344Z",
    stroke: "#464649",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18327 10.8634C9.28784 10.8634 10.1833 9.96801 10.1833 8.86344C10.1833 7.75887 9.28784 6.86344 8.18327 6.86344C7.0787 6.86344 6.18327 7.75887 6.18327 8.86344C6.18327 9.96801 7.0787 10.8634 8.18327 10.8634Z",
    stroke: "#464649",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenBlack);
export default __webpack_public_path__ + "static/media/eye-open-black.669816a2e312606e5f9c5ee1bf5f91e2.svg";
export { ForwardRef as ReactComponent };